module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/attachment-1-9884295862570333bec8737a26935f39.svg";